import DefaultAvatar from './default_avatar.png';

export default {
  DefaultAvatar
};
